// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateOtherSubjectBindingManager, UpdateOtherSubjectBindingManagerSchema } from 'api/gen/UpdateOtherSubjectBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOtherSubjectBindingManagerBaseObject, ValidateOtherSubjectBindingManagerBaseObjectSchema } from 'api/gen/ValidateOtherSubjectBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateOtherSubjectBindingManager'),
  binding: t.union([UpdateOtherSubjectBindingManagerSchema, t.null]),
});

export const ValidateUpdateOtherSubjectBindingManagerSchema = excess(t.intersection([ValidateOtherSubjectBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateOtherSubjectBindingManager extends t.TypeOf<typeof ValidateUpdateOtherSubjectBindingManagerSchema> {}
